import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { AuthProvider } from "./contexts/AuthContext";
import { ProtectedRoute } from "./components/auth/ProtectedRoute";
import { AppLayout } from "./components/app/AppLayout";
import { TooltipProvider } from "./components/ui/tooltip";

import Login from "./pages/Login";
import Accounts from "./pages/Accounts";
import AccountDetail from "./pages/AccountDetail";
import Users from "./pages/Users";
import PromptEditor from "./pages/PromptEditor";
import PromptPlayground from "./pages/PromptPlayground";
import WizardArchive from "./pages/WizardArchive";
import WizardBuilder from "./pages/WizardBuilder";
import WizardJsonReference from "./pages/WizardJsonReference";

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <AuthProvider>
          <TooltipProvider delayDuration={0} skipDelayDuration={0}>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Navigate to="/accounts" replace />} />

            {/* Protected admin routes */}
            <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
              <Route path="/accounts" element={<Accounts />} />
              <Route path="/accounts/:id" element={<AccountDetail />} />
              <Route path="/users" element={<Users />} />
              <Route path="/prompts" element={<PromptEditor />} />
              <Route path="/playground" element={<PromptPlayground />} />
              <Route path="/wizard-builder" element={<WizardArchive />} />
              <Route path="/wizard-builder/new" element={<WizardBuilder />} />
              <Route path="/wizard-builder/:configId" element={<WizardBuilder />} />
              <Route path="/wizard-reference" element={<WizardJsonReference />} />
            </Route>

            <Route path="*" element={<Navigate to="/accounts" replace />} />
          </Routes>
          </TooltipProvider>
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
